import React from "react";
import { Category, ImageType, ProductImageTypes } from "@core/types";
import { useHistory } from "react-router-dom";
import { Image } from "../../../../../components/Image/Image";
import { useGetAllCategoriesQuery } from "../../../../../providers/categories";

interface CategoryProp {
  category: Category;
}

export const CategoryCard = ({ category }: CategoryProp) => {
  const history = useHistory();
  const categoryImage = { ...category.image, type: ProductImageTypes.img } as ImageType;
  const { data: { allCategories } = {} } = useGetAllCategoriesQuery();

  const linkPath = allCategories?.some((c) => c.parent === category.id)
    ? `/categories/${category.id}/subcategories`
    : `/category-detail/${category.id}`;

  const handleOpenUrl = () => {
    history.push(linkPath);
  };

  return (
    <div
      onClick={handleOpenUrl}
      className="relative overflow-hidden rounded-[1.125rem] h-44 w-[7.5rem] min-h-44 min-w-[7.5rem] max-h-44 max-w-[7.5rem] "
    >
      <Image
        lazyLoad={false}
        image={categoryImage}
        className="h-full w-full"
        placeholderClassName="object-contain"
        placeholder={categoryImage.base64 || categoryImage.src}
      />

      <div className="absolute top-0 left-0 right-0 z-10 w-full h-16 pointer-events-none bg-gradient-to-b from-black/65 to-transparent mr-2" />

      <div className="absolute left-0 top-0 m-2 t max-w-[100px] line-clamp-2 break-words whitespace-normal overflow-hidden font-bold text-white z-20 [text-shadow:_0px_0px_0px_rgba(0,0,0,0.8),_0_0_1px_rgba(0,0,0,1)]">
        {category?.name}
      </div>
    </div>
  );
};
